import Core from './core'
export default Core
